/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { shoppingCartControllerAdd } from '../fn/shopping-cart/shopping-cart-controller-add';
import { ShoppingCartControllerAdd$Params } from '../fn/shopping-cart/shopping-cart-controller-add';
import { shoppingCartControllerClear } from '../fn/shopping-cart/shopping-cart-controller-clear';
import { ShoppingCartControllerClear$Params } from '../fn/shopping-cart/shopping-cart-controller-clear';
import { shoppingCartControllerGet } from '../fn/shopping-cart/shopping-cart-controller-get';
import { ShoppingCartControllerGet$Params } from '../fn/shopping-cart/shopping-cart-controller-get';
import { shoppingCartControllerGetItems } from '../fn/shopping-cart/shopping-cart-controller-get-items';
import { ShoppingCartControllerGetItems$Params } from '../fn/shopping-cart/shopping-cart-controller-get-items';
import { shoppingCartControllerRemove } from '../fn/shopping-cart/shopping-cart-controller-remove';
import { ShoppingCartControllerRemove$Params } from '../fn/shopping-cart/shopping-cart-controller-remove';
import { ShoppingCartDto } from '../models/shopping-cart-dto';
import { ShoppingCartItemDto } from '../models/shopping-cart-item-dto';

@Injectable({ providedIn: 'root' })
export class ShoppingCartService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `shoppingCartControllerGet()` */
  static readonly ShoppingCartControllerGetPath = '/api/cart';

  /**
   * Get cart.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shoppingCartControllerGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  shoppingCartControllerGet$Response(params?: ShoppingCartControllerGet$Params, context?: HttpContext): Observable<StrictHttpResponse<ShoppingCartDto>> {
    return shoppingCartControllerGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get cart.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shoppingCartControllerGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  shoppingCartControllerGet(params?: ShoppingCartControllerGet$Params, context?: HttpContext): Observable<ShoppingCartDto> {
    return this.shoppingCartControllerGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<ShoppingCartDto>): ShoppingCartDto => r.body)
    );
  }

  /** Path part for operation `shoppingCartControllerGetItems()` */
  static readonly ShoppingCartControllerGetItemsPath = '/api/cart/items';

  /**
   * Get cart items by product IDs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shoppingCartControllerGetItems()` instead.
   *
   * This method doesn't expect any request body.
   */
  shoppingCartControllerGetItems$Response(params: ShoppingCartControllerGetItems$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ShoppingCartItemDto>>> {
    return shoppingCartControllerGetItems(this.http, this.rootUrl, params, context);
  }

  /**
   * Get cart items by product IDs.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shoppingCartControllerGetItems$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  shoppingCartControllerGetItems(params: ShoppingCartControllerGetItems$Params, context?: HttpContext): Observable<Array<ShoppingCartItemDto>> {
    return this.shoppingCartControllerGetItems$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ShoppingCartItemDto>>): Array<ShoppingCartItemDto> => r.body)
    );
  }

  /** Path part for operation `shoppingCartControllerRemove()` */
  static readonly ShoppingCartControllerRemovePath = '/api/cart/items';

  /**
   * Remove item.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shoppingCartControllerRemove()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shoppingCartControllerRemove$Response(params: ShoppingCartControllerRemove$Params, context?: HttpContext): Observable<StrictHttpResponse<ShoppingCartDto>> {
    return shoppingCartControllerRemove(this.http, this.rootUrl, params, context);
  }

  /**
   * Remove item.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shoppingCartControllerRemove$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shoppingCartControllerRemove(params: ShoppingCartControllerRemove$Params, context?: HttpContext): Observable<ShoppingCartDto> {
    return this.shoppingCartControllerRemove$Response(params, context).pipe(
      map((r: StrictHttpResponse<ShoppingCartDto>): ShoppingCartDto => r.body)
    );
  }

  /** Path part for operation `shoppingCartControllerAdd()` */
  static readonly ShoppingCartControllerAddPath = '/api/cart/add';

  /**
   * Add item.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shoppingCartControllerAdd()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shoppingCartControllerAdd$Response(params: ShoppingCartControllerAdd$Params, context?: HttpContext): Observable<StrictHttpResponse<ShoppingCartDto>> {
    return shoppingCartControllerAdd(this.http, this.rootUrl, params, context);
  }

  /**
   * Add item.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shoppingCartControllerAdd$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shoppingCartControllerAdd(params: ShoppingCartControllerAdd$Params, context?: HttpContext): Observable<ShoppingCartDto> {
    return this.shoppingCartControllerAdd$Response(params, context).pipe(
      map((r: StrictHttpResponse<ShoppingCartDto>): ShoppingCartDto => r.body)
    );
  }

  /** Path part for operation `shoppingCartControllerClear()` */
  static readonly ShoppingCartControllerClearPath = '/api/cart/clear';

  /**
   * Clear cart.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shoppingCartControllerClear()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shoppingCartControllerClear$Response(params: ShoppingCartControllerClear$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return shoppingCartControllerClear(this.http, this.rootUrl, params, context);
  }

  /**
   * Clear cart.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shoppingCartControllerClear$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shoppingCartControllerClear(params: ShoppingCartControllerClear$Params, context?: HttpContext): Observable<boolean> {
    return this.shoppingCartControllerClear$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

}
